<lms-breadcrumb
  [crumbs]="[
    { icon: 'glicon-filing-box', label: 'documents.label', route: '/documents' },
    { route: '.', label: 'documents.create' }
  ]"
></lms-breadcrumb>
<div *ngIf="selectClientQuestion">
  <lms-dynamic-form
    #selectClientForm
    [questions]="selectClientQuestion"
    [title]="'customizations.documents.upload.title'"
    [options]="{ hideSubmit: true }"
    (submit)="submit($event)"
  >
    <ng-content select="[form-actions-before]" form-actions-before></ng-content>
  </lms-dynamic-form>
</div>

<div *ngIf="clientId" class="row">
  <div class="col s12">
    <h3 class="h3">
      {{ 'customizations.documents.upload.description' | translate : { filename: document?.name } }}
    </h3>
  </div>

  <div *ngFor="let option of optionsDocuments" class="col s12 m6 margin-top">
    <gl-radiobutton [options]="[option]" [value]="uploadType" (onChange)="selectOption($event)"></gl-radiobutton>
  </div>

  <div class="col s12 m6">
    <div class="margin-top" [ngClass]="{ disabled: uploadType !== 'file' }">
      <lms-simple-uploader
        [uploadEndPoint]="uploadUrl"
        [uploadData]="uploadData"
        (uploadFinished)="onUploadFinished($event)"
      ></lms-simple-uploader>
    </div>
  </div>

  <div class="col s12 m6">
    <div class="margin-top padding" [ngClass]="{ disabled: uploadType !== 'link' }">
      <lms-dynamic-form #linkForm [questions]="questions" (submit)="submit($event)">
        <ng-content select="[form-actions-before]" form-actions-before></ng-content>
      </lms-dynamic-form>
    </div>
  </div>
</div>
